import React from 'react';
import FormGroupsId from '../form-groups-id/form-groups-id';

const FormGroupsPageId = () => {
    return <FormGroupsId />;
};

export default FormGroupsPageId;
